import { types } from "../types/types";

const initialState = {
    checking: true,
    email: null,
    name: null,
    apellidos: null,
};

export const authReducer = (state = initialState, action) => {
   switch (action.type) {
    case types.authLogin:
      return {
        ...state,
        checking: false,
        ...action.payload, // Aquí llegan: email, name, apellidos (si los mandas)
      };

    case types.authLogout:
      return {
        checking: false,
        email: null,
        name: null,
        apellidos: null,
      };

    case types.authCheckingFinish:
      return {
        ...state,
        checking: false,
      };

    default:
      return state;
  }
};
